// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-toolbar {
  --background: transparent;
  position: absolute;
}

.myReportButton {
  --border-color: var(--ion-color-primary-tint);
  width: calc(283 * var(--width-ratio));
  height: calc(42 * var(--width-ratio));
  margin: auto;
  --border-radius: 30px;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/modal/report-comment-modal/report-comment-modal.page.scss"],"names":[],"mappings":"AAAA;EACE,yBAAA;EACA,kBAAA;AACF;;AAEA;EACE,6CAAA;EACA,qCAAA;EACA,qCAAA;EACA,YAAA;EACA,qBAAA;AACF","sourcesContent":["ion-toolbar {\n  --background: transparent;\n  position: absolute;\n}\n\n.myReportButton {\n  --border-color: var(--ion-color-primary-tint);\n  width: calc(283 * var(--width-ratio));\n  height: calc(42 * var(--width-ratio));\n  margin: auto;\n  --border-radius: 30px;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
